<vdr-card class="mb-2">
<div class="clr-row">
<vdr-form-field [label]="'Section ID'" class="mb-2 clr-col-4">
  <input type="text" placeholder="e.g. hero-1" [formControl]="sectionIdControl" />
  <div class="form-input-hint" *ngIf="sectionIdControl.invalid && sectionIdControl.touched" style="color:red">
    Letters/numbers/dashes only; must start with a letter
  </div>
</vdr-form-field>
<vdr-form-field class="clr-col-2 mb-2 align-button-row">
  <div class="btn btn-secondary h-4" (click)="toggleExpanded()">
    <span>{{ isExpanded ? 'Hide' : 'Display' }}</span>
    <clr-icon *ngIf="isExpanded" shape="arrow up" class="w-3 h-3"></clr-icon>
    <clr-icon *ngIf="!isExpanded" shape="arrow right" class="w-3 h-3"></clr-icon>
  </div>
</vdr-form-field>
</div>

<vdr-card [title]="'Section Styles'" class="mb-2" *ngIf="isExpanded">

  <vdr-form-field class="mb-2">
    <vdr-dynamic-form-input
      [control]="layoutOptionControl"
      [def]="layoutOptionDef">
    </vdr-dynamic-form-input>
  </vdr-form-field>
  <vdr-card [title]="'Section Title & Subtitle Styles'">
      <div class="clr-row mb-2">
        <vdr-form-field [label]="'Title & Subtitle Options'" class="clr-col-6">
          <select [formControl]="titleModeControl">
            <option value="disabled">Disabled</option>
            <option value="for-section">Positioned Above Background</option>
            <option value="for-component">Positioned Within Background</option>
          </select>
        </vdr-form-field>
        <vdr-form-field [label]="'Title Underline'" *ngIf="titleModeControl.value !== 'disabled'" class="clr-col-6">
          <clr-toggle-wrapper>
            <label class="clr-checkbox">
              <input type="checkbox" clrToggle [formControl]="titleUnderlineControl"/>
            </label>
          </clr-toggle-wrapper>
        </vdr-form-field>
      </div>
      <div *ngIf="titleModeControl.value !== 'disabled'" class="mb-2">
        <vdr-form-field [label]="'Section Title'">
          <vdr-dynamic-form-input [control]="titleControl" [def]="textValueDef"></vdr-dynamic-form-input>
        </vdr-form-field>
        <vdr-form-field [label]="'Section Subtitle'">
          <vdr-dynamic-form-input [control]="subtitleControl" [def]="textValueDef"></vdr-dynamic-form-input>
        </vdr-form-field>
      </div>
  </vdr-card>

  <vdr-card [title]="'Component Styles'">
    <vdr-form-field [label]="'Component Type'" class="mb-2">
      <select [formControl]="pageComponentTypeControl">
        <option value="" disabled>Select A Banner Type</option>
        <option value="marketing-banner">Marketing Banner</option>
        <option value="hero-section">Hero Section</option>
        <option value="key-point-list">Key Point List</option>
        <option value="card-carousel-banner">Card Carousel Banner</option>
        <option value="external-html-content">Custom HTML</option>
        <option value="faq-list">FAQ List</option>
        <option value="featured-collection">Featured Product Collection</option>
        <option value="product-info-section">Product Information Section</option>
        <option value="simple-product-info-section">Product Information Section - Custom</option>
        <option value="product-listing-section">Products Listing Section</option>
        <option value="product-reviews">Product Reviews</option>
        <option value="top-reviews">Top Reviews</option>
        <option value="email-subscription">Email Subscription Form</option>
        <option value="contact-form">Contact Form</option>
        <option value="about-form">About Form (deprecated)</option>
        <option value="collection-carousel">Collection Carousel (deprecated)</option>
        <option value="collection-group">Collections Group (deprecated)</option>
      </select>
    </vdr-form-field>

    <ng-container *ngIf="pageComponentTypeControl.value === 'marketing-banner'">
      <vdr-form-field>
        <vdr-dynamic-form-input #marketingBannerInput
          [control]="marketingBannerControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'key-point-list'">
      <vdr-form-field>
        <vdr-dynamic-form-input #keyPointListInput
          [control]="keyPointListControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'card-carousel-banner'">
      <vdr-form-field>
        <vdr-dynamic-form-input #cardCarouselBannerInput
          [control]="cardCarouselBannerControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'hero-section'">
      <vdr-form-field>
        <vdr-dynamic-form-input #heroSectionInput
          [control]="heroSectionControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'external-html-content'">
      <vdr-form-field>
        <vdr-dynamic-form-input #externalHtmlContentInput
          [control]="externalHtmlContentControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'faq-list'">
      <vdr-form-field>
        <vdr-dynamic-form-input #faqListInput
          [control]="faqListControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'featured-collection'">
      <vdr-form-field>
        <vdr-dynamic-form-input #featuredCollectionInput
          [control]="featuredCollectionControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'top-reviews'">
      <vdr-form-field>
        <vdr-dynamic-form-input #topReviewsInput
          [control]="topReviewsControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'collection-group'">
      <vdr-form-field>
        <vdr-dynamic-form-input #collectionsGroupInput
          [control]="collectionsGroupControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'email-subscription'">
      <vdr-form-field>
        <vdr-dynamic-form-input #emailSubscriptionInput
          [control]="emailSubscriptionControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'product-info-section'">
      <vdr-form-field>
        <vdr-dynamic-form-input #productInfoSectionInput
          [control]="productInfoControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'simple-product-info-section'">
      <vdr-form-field>
        <vdr-dynamic-form-input #simpleProductInfoSectionInput
          [control]="simpleProductInfoControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'product-listing-section'">
      <vdr-form-field>
        <vdr-dynamic-form-input #productListingSectionInput
          [control]="productListingControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'collection-carousel'">
      <vdr-form-field>
        <vdr-dynamic-form-input #collectionCarouselInput
          [control]="collectionCarouselControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'contact-form'">
      <vdr-form-field>
        <vdr-dynamic-form-input #contactFormInput
          [control]="contactFormControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'about-form'">
      <vdr-form-field>
        <vdr-dynamic-form-input #aboutFormInput
          [control]="aboutFormControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
    <ng-container *ngIf="pageComponentTypeControl.value === 'product-reviews'">
      <vdr-form-field>
        <vdr-dynamic-form-input #productReviewsInput
          [control]="productReviewsControl"
          [def]="currentComponentInputDef"
        >
        </vdr-dynamic-form-input>
      </vdr-form-field>
    </ng-container>
  </vdr-card>
</vdr-card>

</vdr-card>
